import React from 'react';
import {Outlet} from 'react-router-dom';

const DocExplorer: React.FC = () => {
  return <Outlet />;
};

export default DocExplorer;
